import { TokenInfo } from "@/models/response/auth";

const getToken = (): TokenInfo | null => {
  const token = localStorage.getItem("token");
  if (token) return JSON.parse(token);
  return null;
};

export const setToken = (token: TokenInfo | null) => {
  if (token) {
    localStorage.setItem("token", JSON.stringify(token));
  } else {
    localStorage.removeItem("token");
  }
};

export default getToken;
